<template>
    <a id="ebooksBox" :href="ebookItemLink(item)">
        <img :src="item.image" class="poster">
        <div class="content-wrapper">
            <div class="title">{{item.title}}</div>
            <div class="date">{{formatDate(item.date)}}</div>
            <div class="details " v-html="item.summary"></div>
            <button class="book-now">{{t('ebook_CTA')}}</button>

            <div class="icon" :style="{marginTop : typeof item.main_image != 'undefined' ? '0.75rem' : '0'}">
                <img v-for="symbol in item.symbols" :key="symbol" :src="getSymbolImageSrc(symbol)"
                     :class='{hide: getSymbolImageSrc(symbol) == ""}' class="img-responsive symbol-image">
            </div>
        </div>
    </a>
</template>
<script>
    import moment from "moment";
    import {mapState, mapGetters} from "vuex";

    export default {
        name: "CardNews",
        props:{
            item: {
                type: Object,
                required: true
            }
        },

        computed:{
          ...mapState(['lang', 'webInfo']),
            ...mapGetters(['t','getSymbolImageSrc'])
        },
        methods:{
            formatDate(date){
              moment.locale(this.lang);
              const dateAsCETtz = moment(date+"+01:00"); //treat the hard coded time as if it is CET +1
              return dateAsCETtz.format('MMM DD, YYYY');
            },
            ebookItemLink(item){
              return `${this.webInfo.getFullHostWithProtocol()}/plus/ebooks/${item.friendly_url}`; //relative link isn't possible. this component is sometime displayed as part of instruments page
            },
            dontShow(event){
                event.target.style.display = 'none';
            }
        }
    }
</script>
<style lang="scss" scoped>
    #ebooksBox{
        @media (min-width: 768px){
            max-width:47.4%;
        }
        @media (max-width: 768px){
          max-width: 20.5rem;
          margin-bottom: 17px;
        }
        display: flex;
        flex-direction: row;
        margin: 0 auto 1.875rem;
        padding: 1rem 0;
        border-radius: 0.1875rem;
        border:1px solid #d5d3d3;
        -webkit-transition: 0.3s;
        transition: 0.3s;
        cursor: pointer;
        @media (max-width: 768px){
            flex-direction: column;
        }

        & > img{
          padding: 0 1rem 0 0.5rem;
        }
        &:hover{
          background-color: #f5f5f5;
        }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    @media (min-width: 768px) {
      padding-right: 1rem;
    }
    @media (max-width: 768px) {
      padding: 0 0.625rem;
    }
  }
  .title {
    //margin-bottom: 0.125rem;
    font-size: 1rem;
    font-weight: 500;
  }
  .date {
    font-size: 0.875rem;
    color: #9e9e9e;
    margin-bottom: 0.75rem;
  }
  .details {
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
    min-height: 62px;
  }
  .poster {
    height: 13.0625rem; //calculated differently from the design, because at the design the image included the padding above and below
    align-self: center;
    @media (max-width: 768px) {
      height: 10.21rem; //calculated differently from the design, because at the design the image included the padding above and below
      margin-bottom: 0.125rem;
    }
  }
  .icon {
    margin-top: 0.75rem;
    display: flex;
    @media (max-width: 768px) {
      justify-content: center;
    }
    .symbol-image {
      margin-right: 0.625rem;
      position: relative;
      width: 1.125rem;
      height: 1.125rem;
      &:last-of-type {
        margin-right: 0;
      }
      &.hide {
        display: none;
      }
    }
  }
  .book-now {
    min-width: 123px;
    height: 32px;
    font-size: 1rem;
    color: #424242;
    margin: 0.5rem auto 1rem 0;
    border: 1px solid #7a7c7c;
    border-radius: 3px;
    color: #424242;
    font-weight: 500;
    background-color: white;
    @media (max-width: 768px) {
      margin-left: auto;
    }
    &:hover {
      background-color: #1c79be;
      color: #ffffff;
      border: none;
    }
    &:focus {
      outline: none;
    }
  }

        .img-or-video{
            position: relative;
            width: 18.5rem;
            height: 13.75rem;
            margin: 0.75rem auto 0;
            background-repeat: no-repeat;
            background-position: center;
            background-size:cover;
        }
    }
    .ar{
        #ebooksBox{
            .icon{
                .symbol-image{
                    margin: 0 0 0 0.625rem;
                }
            }
          .book-now{
            margin: 0.5rem 0 0.25rem auto;
            @media (max-width: 768px){
              margin-right: auto;
            }
          }
        }
    }
</style>
